import React, { useState } from 'react'
import { IPasswordConfirmProps } from '../../../types/interfaces/IPasswordConfirmProps'
import {
  PasswordInputContainer,
  Input,
  Label,
  InputContainer,
  ShowPasswordButton,
} from './style'
import { Error } from '../error/Error'
import { SignupTexts } from '../../../constants/signup-texts'
import { HeightPlaceHolderForError } from '../email-confirm-input/style'

export const PasswordConfirmInput: React.FC<IPasswordConfirmProps> = ({
  callback,
  hasError,
  errorText,
  password,
  className,
}) => {
  const [passwordType, setPasswordType] = useState<'password' | 'text'>(
    'password',
  )

  const handleChange = (e: any) => {
    e.preventDefault()
    const error = !(e.target.value === password)
    callback(e.target.value, error)
  }

  const togglePasswordType = (e: any) => {
    e.preventDefault()
    if (passwordType === 'password') {
      setPasswordType('text')
      return
    }
    setPasswordType('password')
  }

  return (
    <PasswordInputContainer
      className={`passwordConfirm ${className ?? ''} ${
        hasError ? 'error' : ''
      }`}
    >
      <Label htmlFor="passwordConfirm">
        {SignupTexts.EnterPasswordOneMoreTime}
      </Label>
      <InputContainer>
        <Input
          type={passwordType}
          name="passwordConfirm"
          onChange={(e: any) => handleChange(e)}
        ></Input>
        <ShowPasswordButton onClick={togglePasswordType} type="button">
          {passwordType === 'password' ? (
            <i className="password-eye"></i>
          ) : (
            <i className="password-eye-hide"></i>
          )}
        </ShowPasswordButton>
      </InputContainer>
      <HeightPlaceHolderForError>
        <Error hasError={hasError} errorText={errorText}></Error>
      </HeightPlaceHolderForError>
    </PasswordInputContainer>
  )
}
